<template>
  <div
    v-if="showNpl ||showNplTips"
    style="height: 100%;"
  >
    <div
      v-if="showNpl"
      class="npl-contain"
    >
      <div class="npl-header">
        <view
          class="npl-header__close"
          @click="resetListen"
        >
          x
        </view>
      </div>
      <div class="npl-content">
        <component
          :is="comName"
          :key="comId"
          :dw-list="dwList"
          :sel-dw="selDw"
          :sel-quest="selQuest"
        />
      </div>

      <div class="npl-foot" />
    </div>

    <div
      v-if="showNplTips"
      class="npl-contain"
    >
      <div class="npl-zb-model">
        <img
          class="dev-weomen"
          src="/3DModel/npl/women.png"
        >
      </div>
      <div class="npl-tips">
        <transition name="fade">
          <div
            v-if="sendingScroll"
            style="width: 100%;height: 56px"
            class="yuyin-contain"
          />
        </transition>

        <div class="npl-tips__title">
          您可以这样说：
        </div>
        <div class="npl-tips__labs">
          <div
            v-for="(item) in nplConfig"
            :key="item.id"
            class="npl-tips__labs__lab dev-click"
            @click="clickZl(item.lab)"
          >
            {{ item.lab }}
          </div>
        </div>
        <div class="npl-tips__Text">
          {{ nplTips }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NplDwxf from './npl-dwxf.vue';
import NplDw from './npl-dw.vue';
import NplZb from './npl-zb.vue';
import NplXfswg from './npl-xfswg.vue';
import NplXfxj from './npl-xfxj.vue';
import NplXfjc from './npl-xfjc.vue';
import NplXfby from './npl-xfby.vue';
import { nplService } from './npl.service';
import EventBus from '@/event-bus';
export default {
  name: 'Npl',
  components: {
    NplDwxf,
    NplDw,
    NplZb,
    NplXfswg,
    NplXfxj,
    NplXfjc,
    NplXfby
  },
  props: {
    dwList: {
      type: Array,
      default: () => {
        return [
        ];
      }
    }
  },
  data () {
    return {
      comName: 'NplDwxf',
      comId: null,
      isListen: false,
      stateListen: '',
      showNpl: false,
      showNplTips: false,
      nplTips: '我正在听...',
      mainApp: null, // 语音唤醒API
      nplConfig: null, // 语音识别规则
      selDw: null, // 语音所选单位
      selQuest: null, // 语音问题
      loadingCj: null,
      sendingScroll: false // 正在发送语音 滚动状态
    };
  },
  methods: {
    listen () {
      const _this = this;
      // _this.showNpl = false;
      if (!this.isListen) {
        _this.isListen = true;
        _this.showNplTips = true;
        nplService.play('我在', () => {
          _this.doListen();
          // 开启滚动条
          _this.beginSendYy();
        });
      }
    },
    // 关闭麦克风
    recorderOut () {
      if (window.localStream) {
        window.localStream.getTracks().forEach(track => track.stop());
      }
    },
    doListen () {
      const _this = this;
      _this.stateListen = '';
      nplService.listen((text) => {
        // 显示识别文字
        _this.stateListen !== 'end' && (_this.nplTips = text || '我正在听...');
      }, (_text) => {
        // 识别结束
        _this.stateListen = 'end';
        // 关闭滚动条
        _this.endSendYy();

        if (!_this.showNplTips) {
          // 关闭人机对话，关闭麦克风
          _this.recorderOut();
          return;
        }
        // const instructJqr = new RegExp('(系统介绍|介绍系统)').test(_text);
        // if (instructJqr) {
        //   // 发送指令
        //   nplService.stopListen();
        //   _this.resetListen();
        //   _this.recorderOut();
        // }

        const exitCom = new RegExp('^(退出|关闭)').test(_text);
        if (exitCom) {
          // 返回首页
          _this.showNpl = false;
          nplService.play('好的', () => {
            _this.resetListen();
            // 关闭人机对话，关闭麦克风
            _this.recorderOut();
          });
          return;
        }
        this.getZjm(_text);
      });
    },

    /**
     * 获取数据库配置得指令词
     */
    getZjm (_text) {
      const _this = this;
      if (!_text) {
        this.handleListenFail(_text);
        return;
      }

      // 返回首页命令
      if (new RegExp('.*返回.*首页.*').test(_text)) {
        _this.nplTips = '正在返回首页...';
        nplService.play('好的', () => {
          _this.returnToHome();
          _this.resetListen();
        });
        return;
      }

      // 查看建筑命令
      if (new RegExp('.*查看.*').test(_text)) {
        _this.nplTips = '正在为您查看建筑...';
        nplService.play('好的', () => {
          _this.viewBuilding(_text);
          _this.resetListen();
        });
        return;
      }

      // 跳转火警命令
      if (new RegExp('.*跳转.*火警.*').test(_text)) {
        _this.nplTips = '正在跳转火警页面...';
        nplService.play('好的', () => {
          _this.jumpToFireAlarm();
          _this.resetListen();
        });
        return;
      }
      // 未识别到有效指令
      this.handleListenFail(_text);
    },
    /**
     * 点击对话指令标签跳转场景
     */
    clickZl (_text) {
      // const _this = this;
      // _this.loadingCj = this.$loading({
      //   lock: true,
      //   text: '场景加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      // console.log(_text);
      this.getZjm(_text);
    },
    /**
     * @description: 接听失败处理
     * @return {*}
     * @param {*} text 文本
     */
    handleListenFail (text) {
      console.log(text);
      const _this = this;

      const isNullText = !text || text === '';
      const failTips = isNullText ? '对不起，没听到你说话，请重试' : '对不起，没理解，请重试';
      _this.nplTips = failTips;
      // this.$refs.NplMode.playUnknow();
      nplService.play(failTips, () => {
        // isNullText && _this.resetListen();
        // !isNullText && _this.doListen();
        _this.resetListen();
      });
    },
    change () {
      // this.selQuest = '我的问题';
      // this.selDw = this.dwList[0];
      // this.showNpl = true;
      this.resetListen();
      let i = this.nplConfig.findIndex(item => item.name === this.comName);
      i = i === this.nplConfig.length - 1 ? 0 : i + 1;
      this.comName = this.nplConfig[i].name;
    },
    resetListen () {
      this.isListen && nplService.stopListen();
      this.showNplTips = false;
      this.isListen = false;
      this.nplTips = '我正在听...';
      // 关闭滚动条
      this.endSendYy();
      // eslint-disable-next-line no-undef
      wait2Wakeup();
    },
    // 开始发送语音
    beginSendYy () {
      console.log('开始监听');
      // 打开滚动条
      this.sendingScroll = true;
    },
    // 结束发送语音
    endSendYy () {
      console.log('结束监听');
      // 关闭滚动条
      this.sendingScroll = false;
    },
    computeNplConfig () {
      // 单位名称正则表达式
      this.nplConfig = [
        {
          lab: '"返回首页"',
          name: 'NplHome',
          question: new RegExp('.*返回.*首页.*')
        },
        {
          lab: '"查看XXX楼"',
          name: 'NplJzw',
          question: new RegExp('.*查看.*')
        },
        {
          lab: '"跳转火警"',
          name: 'NplFire',
          question: new RegExp('.*跳转.*火警.*')
        }
        // {
        //   lab: '“查看所有单位的消防情况”',
        //   name: 'NplDwxf',
        //   question: new RegExp('^[看|查].*所有单位.*消防情况.{0,1}$')
        // },
        // {
        //   lab: '“查看所有单位的消防巡查情况”',
        //   name: 'NplXfxj',
        //   question: new RegExp('^[看|查].*所有单位.*消防巡查情况.{0,1}$')
        // },
        // {
        //   lab: '“查看所有单位的消防检测情况”',
        //   name: 'NplXfjc',
        //   question: new RegExp('^[看|查].*所有单位.*消防检测情况.{0,1}$')
        // },
        // {
        //   lab: `查看${this.dwList[0] ? this.dwList[0].name : 'xx单位'}的消防情况`,
        //   name: 'NplDw'
        // },
        // {
        //   lab: `“查看${this.dwList[0] ? this.dwList[0].name : 'xx单位'}今日的值班情况”`,
        //   name: 'NplZb',
        //   question: new RegExp(`^[看|查].*(${dwEeg}).*值班情况.{0,1}$`)
        // },
        // {
        //   lab: `“查看${this.dwList[0] ? this.dwList[0].name : 'xx单位'}的水管网情况”`,
        //   name: 'NplXfswg',
        //   question: new RegExp(`^[看|查].*(${dwEeg}).*水管网情况.{0,1}$`)
        // }
      ];
    },
    /**
     * 返回首页方法
     */
    returnToHome () {
      // 返回首页的实现逻辑
      console.log('执行返回首页操作');
      // TODO: 实现返回首页的具体逻辑
      EventBus.$emit('returnToHome');
    },

    /**
     * 查看建筑方法
     * @param {String} text - 语音识别的文本，可能包含具体建筑名称
     */
    viewBuilding (text) {
      // 查看建筑的实现逻辑
      console.log('执行查看建筑操作', text);
      // TODO: 实现查看建筑的具体逻辑
      // 可以从text中提取具体的建筑名称
      EventBus.$emit('viewBuilding', text);
    },

    /**
     * 跳转火警方法
     */
    jumpToFireAlarm () {
      // 跳转火警的实现逻辑
      console.log('执行跳转火警操作');
      // TODO: 实现跳转火警的具体逻辑
      // 数字键4
      EventBus.$emit('controlShowHj', true, false);
    },

    playVoice (str) {
      // 播放文字语音
      const _this = this;
      _this.isListen = true;
      nplService.stopPlay();
      nplService.play(str, () => {
        _this.resetListen();
      });
    }
  },
  watch: {
    dwList (newVal, oldVal) {
      this.computeNplConfig();
    }
  },
  created () {
    console.log('重新唤醒');
    this.computeNplConfig();
    const _this = this;
    EventBus.$on('setCloseNpl', function (data) {
      _this.closeNpl = data;
      if (!data) {
        // 重启启动语音唤醒
        _this.reconnectMinApp();
      }
    });

    // 定时重新连接
    setInterval(() => {
      // 重启启动语音唤醒
      _this.reconnectMinApp();
    }, 1000 * 180);

    EventBus.$on('openYysb', function (data) {
      _this.listen();
    });

    EventBus.$on('stopPlay', function (data) {
      console.log('stopPlay');
    });

    if (window.app_register) {
      window.app_register({
        onWenkenup: function () {
          _this.listen();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">

.npl-contain {
  height: 90%;
  margin: 11px;
  border: solid 1px #2667ae;
  text-align: center;
  background-image: linear-gradient(269deg, rgba(14, 33, 70, 0.24) 0%, rgba(12, 29, 63, 0.64) 10%, rgba(0, 9, 28, 0.72) 99%);
}

.npl-header {
  width: 100%;
  height: 6%;
  background: url('/3DModel/npl/header.png') no-repeat center center;
  background-size: cover;

  &__close {
    font-size: 43px;
    position: absolute;
    right: 0;
    top: 0;
    color: aliceblue;
    width: 65px;
  }
}

.npl-content {
  width: 100%;
  height: 88%;
}

.npl-foot {
  width: 100%;
  height: 6%;
  background: url('/3DModel/npl/foot.png') no-repeat center center;
  background-size: cover;
}

.npl-tips {
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  height: 180px;
  padding: 20px;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.7);

  &__title {
    font-size: 20px;
    color: rgb(255, 255, 255);
  }

  &__labs {
    display: inline-block;
    margin: 10px 0;

    &__lab {
      display: inline-block;
      padding: 10px 20px;
      margin-right: 10px;
      border-radius: 25px;
      font-size: 16px;
      color: #fff;
      text-align: center;
    }

    & &__lab:last-child {
      margin-top: 10px;
    }

    & &__lab:nth-child(4n+1) {
      background-color: #34abfa;
    }

    & &__lab:nth-child(4n+2) {
      background-color: #92abf5;
    }

    & &__lab:nth-child(4n+3) {
      background-color: #f8bd45;
    }

    & &__lab:nth-child(4n+4) {
      background-color: #30b4bb;
    }
  }

  &__Text {
    margin-top: 10px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    color: #fff;
  }
}

.dev-click:hover{
  border: 1.5px solid #379ffe;
  box-shadow: 0 0 10px 2.5px rgb(55 159 254 / 100%);
  font-size: 17px;
}
.dev-weomen {
  width: 425px;
  height: 600px;
  position: fixed;
  top: 20%;
  left: 40%;
}

.yuyin-contain {
  position: absolute;
  top: -30px;
  background-image: url('/3DModel/npl/矢量智能对象.png');
  background-repeat: repeat-x;
  animation: textScroll 250s infinite linear normal;
  animation-direction: alternate;
  animation-fill-mode: both;
  animation-timing-function: linear;
}

@keyframes textScroll {
  0% {
    /*使用background-position制作动画效果*/
    background-position: 0 0;
  }
  100% {
    /*移动位置由图片实际大小决定*/
    background-position: -90000px 0;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
